import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Highlighter from 'react-highlight-words';
import { Space, Tag, Table, Button, Input, Select, PageHeader, Row, Col, DatePicker, Spin, message as messageAntd, Statistic, Card } from 'antd';
import { AudioOutlined, SearchOutlined, FileExcelOutlined, LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useVT } from 'virtualizedtableforantd4';
import moment from 'moment'
import { CSVLink } from "react-csv";
import { currency, formatterMetrico, onlyTwoDigits } from '../helpers/formatter'
import { getGlobalData, changeFilter, getData, resetData, downloadCsvData } from '../actions/reports';
import './reports.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const { Search } = Input;
const { Option } = Select;

function Reports(props) {

  const history = useHistory();

  const csvLink = useRef()

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const [filterData, setFilterData] = useState(null)
  const [registros, setRegistros] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({})
  const csvData = useSelector(state => state.reports.csvData)
  const csvName = useSelector(state => state.reports.csvName)

  const marcas = useSelector(state => state.reports.marcas)
  const reportes = useSelector(state => state.reports.reportes)
  const [unidades, setUnidades] = useState([])
  const loading = useSelector(state => state.reports.loading)

  const idReporte = useSelector(state => state.reports.idReporte)
  const idMarca = useSelector(state => state.reports.idMarca)
  const idUnidad = useSelector(state => state.reports.idUnidad)
  const anio = useSelector(state => state.reports.anio)
  const mes = useSelector(state => state.reports.mes)
  const data = useSelector(state => state.reports.data)
  const extraData = useSelector(state => state.reports.extraData)
  const columnsData = useSelector(state => state.reports.columnsData)

  const timerSearch = useRef(null)

  const dispatch = useDispatch();

  const [vt] = useVT(() => ({
    scroll: { y: "70vh" },
    onScroll: ({ isEnd }) => {
      if (isEnd) {
        console.log("loadDataByChunk");
      }
    }
  }), [data]);

  useEffect(() => {
    dispatch(resetData())
    dispatch(getGlobalData())
    return () => clearTimeout(timerSearch)
  }, []);


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('')
  };


  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {

          }}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}>
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        <div>{text}</div>
      ),
  });

  const distinct = (key) => {

    let unique = []
    if (filterData) {
      if (filterData.length > 0) {
        unique = [...new Set(filterData.map(item => item[key]))];
      }
    } else if (registros) {
      if (registros.length > 0) {
        unique = [...new Set(registros.map(item => item[key]))];
      }
    } else {
      unique = [...new Set(data.map(item => item[key]))];
    }



    let filters = []
    for (let i = 0; i < unique.length; i++) {

      filters.push({ text: unique[i], value: unique[i] })

    }
    return filters
  }


  const createColumns = (columnsData, data, filteredInfo, filterData, registros) => {
    if (!data) {
      return null
    }
    console.log("createColumns------", filterData ? filterData.length : 0)
    let _columns = []
    for (let i = 0; i < columnsData.length; i++) {
      let item = columnsData[i]
      let column = {}

      column.dataIndex = item.index


      if (item.width !== 0) {
        column.minWidth = item.width
        column.width = item.width
      }
      if (item.fixed !== "") {
        column.fixed = item.fixed
      }

      switch (item.tipo) {
        case "total":
          let total = 0
          if (filterData) {
            if (filterData.length > 0) {
              total = filterData.length;
            }
          } else if (registros) {
            if (registros.length > 0) {
              total = registros.length;
            }
          } else {
            total = data.length
          }
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>{item.nombre}
              <div style={{ color: 'slategray', fontWeight: '400' }}>({total})</div></div>
          }
          column.className = "m-nowrap large"
          break
        case "sumCurrency":
        case "sum":
          let sum = 0
          if (filterData) {
            if (filterData.length > 0) {
              sum = filterData.map(i => i[item.index]).reduce((prev, next) => prev + next);
            }

          } else if (registros) {
            if (registros.length > 0) {
              sum = registros.map(i => i[item.index]).reduce((prev, next) => prev + next);
            }

          } else if (data.length > 0) {
            sum = data.map(i => i[item.index]).reduce((prev, next) => prev + next);
          }
          sum = item.tipo === "sumCurrency" ? currency.format(sum, 2) : onlyTwoDigits.format(sum)
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>{item.nombre}
              <div style={{ color: 'slategray', fontWeight: '400' }}>({sum})</div>
            </div>
          }
          column.className = "m-nowrap large"
          break
        default:
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>
              {item.nombre}
            </div>
          }
          column.className = "m-nowrap"
          break
      }

      switch (item.sorter) {
        case "number":
          column.sorter = (a, b) => a[item.index] - b[item.index]
          break
        case "date":
          column.render = (text) => (<div> {moment(text, 'YYYY-MM-DD').format('DD/MM/YYYY')} </div>)
          column.sorter = (a, b) => moment(a[item.index]).unix() - moment(b[item.index]).unix()
        default:
          break
      }

      switch (item.filtro) {
        case "distinct":
          column.filters = distinct(item.index)
          column.onFilter = (value, record) => record[item.index].indexOf(value) === 0
          break
        case "search":
          column = { ...column, ...getColumnSearchProps(item.index) }
        default:
          break
      }

      switch (item.formato) {
        case "currency":
          column.render = (text) => (<div> {currency.format(text)} </div>)
          break
        default:
          break
      }

      column.filteredValue = filteredInfo[item.index] || null

      _columns.push(column)
    }
    return _columns;
  }

  const columns = useMemo(() => createColumns(columnsData, data, filteredInfo, filterData, registros), [filterData, columnsData, filteredInfo]);

  function onSearch(value) {
    clearInterval(timerSearch.current)
    timerSearch.current = setTimeout(() => {
      const filter = data.filter(o =>
        Object.keys(o).some(k =>
          String(o[k])
            .toLowerCase()
            .includes(value.toLowerCase())
        )
      );
      value === "" ? setFilterData(null) : setFilterData(filter)
      setRegistros(null)
      setFilteredInfo({})
    }, 600)

  }

  function downloadCSV() {
    dispatch(downloadCsvData()).then(() => {
      csvLink.current.link.click()
    })
  }

  const handleTableChange = (pagination, filters, sorters, extra) => {

    setRegistros(extra.currentDataSource)
    setFilteredInfo(filters)
  }

  function onChangeFilter(key, value, option) {

    if (key === "idMarca") {
      dispatch(changeFilter("idUnidad", null))
      setUnidades(marcas[option.key].marcaUnidades)
    }

    setFilterData(null)
    setRegistros(null)
    setFilteredInfo({})
    dispatch(changeFilter(key, value))
  }

  function onChangeDate(date, dateString) {
    console.log(date, dateString)
    if (date != null) {
      dispatch(changeFilter("anio", date.format("YYYY")))
      dispatch(changeFilter("mes", date.format("MM")))
    }


  }

  function loadData() {
    if (idReporte === null || idMarca === null || idUnidad === null || anio === null || mes === null) {
      messageAntd.warning('Todos los filtros son necesarios');
    } else {
      setFilteredInfo({})
      setSearchText('')
      setFilterData(null)
      setRegistros(null)
      dispatch(getData())
    }
  }

  const exportInventarioExcel = () => {
    const urlExportExcel = `https://metricsapi.gpoptima.info/reportes/data?idReporte=${idReporte}&idMarca=${idMarca}&idUnidad=${idUnidad}&anio=${anio}&mes=${mes}`;
    const user = JSON.parse(localStorage.getItem('@@auth_user'));
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte');

    fetch(`${urlExportExcel}`, { headers: { 'Authorization': `Bearer ${user.token}` } })
      .then((res) => res.json())
      .then(result => {
        const { data } = result.result;

        const objects = data[0];
        const keys = Object.entries(objects);
        let columnsExcel = [];

        keys.forEach(entries => {
          const arrayKey = entries[0];

          columnsExcel = [...columnsExcel, { header: arrayKey.toUpperCase(), key: arrayKey }];
        });

        worksheet.columns = columnsExcel;

        data.forEach(element => {
          worksheet.addRow(element);
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer]), `reporte.xlsx`);
        });
      });
  }

  const isNumber = (value) => {
    return typeof value === 'number' &&
      isFinite(value);
  }


  return (
    <div style={{ margin: "18px" }}>
      <Spin spinning={loading} tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
        <PageHeader
          className="m-page-header"
          onBack={null}
          title={<div style={{ fontSize: "18px" }}>Reportes</div>}
          subTitle={
            null
          }
          extra={[
            <Button
              key="0"
              shape="circle"
              type="primary"
              onClick={() => {
                exportInventarioExcel();
              }}
              style={{ background: "green", borderColor: "green" }}>
              <FileExcelOutlined />
            </Button>,
            // <CSVLink
            //   style={{ display: 'none' }}
            //   ref={csvLink}
            //   target='_blank'
            //   filename={csvName}
            //   key="1"
            //   data={csvData}>
            // </CSVLink>,
            <input
              key="2"
              style={{ border: "1px solid lightslategray", borderRadius: "3px" }}
              placeholder=" Buscar..."
              type="search"
              onChange={(e) => onSearch(e.target.value)} />
          ]} />
        <div>
          <Select
            onChange={(value, option) => onChangeFilter("idReporte", value, option)}
            showSearch
            style={{ width: 200, marginRight: "8px" }}
            placeholder="Selecciona un reporte"
            optionFilterProp="children"
            value={idReporte}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {reportes.map((item, index) => (
              <Option key={index} value={item.id}>{item.nombre}</Option>
            ))}
          </Select>
          <Select
            placeholder="Marca"
            value={idMarca}
            style={{ width: 150, marginRight: "8px" }} onChange={(value, option) => onChangeFilter("idMarca", value, option)}>
            {marcas.map((item, index) => (
              <Option key={index} value={item.id}>{item.nombre}</Option>
            ))}
          </Select>
          <Select
            placeholder="Unidad"
            value={idUnidad}
            style={{ width: 120, marginRight: "8px" }} onChange={(value, option) => onChangeFilter("idUnidad", value, option)}>
            {unidades.map((item, index) => (
              <Option key={index} value={item.unidad.id}>{item.unidad.nombre}</Option>
            ))}
          </Select>


          <DatePicker
            onChange={onChangeDate}
            placeholder="Mes"
            style={{ width: 120, marginRight: "8px" }}
            picker="month" />

          <Button type="primary" onClick={loadData}>
            Consultar
          </Button>

        </div>
        {extraData?.data ? <div>
          <div className="m-statistic-card">
            <Row gutter={16}>
              <Col span={12}>
                <Card>
                  {
                    extraData.data?.filteredTijuana?.length > 0 ? (
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Ventas {anio}</th>
                            {
                              extraData.data?.filteredTijuana?.map((item, index) => {
                                if (index === extraData.data?.filteredTijuana.length - 1) {
                                  return (<th>Servicio {extraData.data?.filteredTijuana[index - 1]?.year + 1 || new Date().getFullYear().toString()}</th>)
                                }
                                return (<th>Servicio {item.year}</th>)
                              })
                            }
                          </tr>
                        </thead>
                        <tbody>
                          {
                            extraData.data?.filteredTijuana?.length > 0 && (
                              <tr>
                                <td>{extraData?.data?.filteredTijuana[0]?.nombre}</td>
                                <td>{extraData?.data?.filteredTijuana[0]?.val1}</td>
                                {extraData?.data?.filteredTijuana.map((item) => (
                                  <td>{item.val2}</td>
                                ))}
                              </tr>
                            )
                          }
                          {
                            extraData?.data?.filteredTijuana?.length > 0 && (
                              <tr>
                                <td>{extraData?.data?.filteredMexicali[0]?.nombre}</td>
                                <td>{extraData?.data?.filteredMexicali[0]?.val1}</td>
                                {extraData?.data?.filteredMexicali.map((item, index) => {
                                  if (index === extraData.data?.filteredMexicali.length - 1) {
                                    return null
                                  }
                                  return (<td>{item.val2}</td>)
                                })}
                              </tr>
                            )
                          }
                          {extraData?.data?.filteredEnsenada?.length > 0 && (
                            <tr>
                              <td>{extraData?.data?.filteredEnsenada[0]?.nombre}</td>
                              <td>{extraData?.data?.filteredEnsenada[0]?.val1}</td>
                              {extraData?.data?.filteredEnsenada.map((item) => (
                                <td>{item.val2}</td>
                              ))}
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : extraData.data.length > 0 ? (
                      (<table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Ventas {anio}</th>
                            {extraData?.data?.map((item) => (
                              <th> Servicio {item?.year}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr key={extraData?.data[0]}>
                            <td>{extraData?.data[0].nombre}</td>
                            <td>{extraData?.data[0].val1}</td>
                            {extraData?.data?.map((item) => (
                              <td>{item?.val2}</td>
                            ))}
                          </tr>
                        </tbody>
                      </table>)
                    ) : null
                  }
                  {/* <table style={{width:'100%'}}>
                        <thead>
                        <tr>
                          <th></th>
                          <th>Ventas {anio}</th>
                          {extraData?.data?.map((item,index) => (
                            <th> Servicio {item.year}</th>
                          ))}
                        </tr>
                        </thead>
                         <tbody>
                          <tr key={extraData.data[0]}>
                              <td>{extraData.data[0].nombre}</td>
                              <td>{extraData.data[0].val1}</td>
                              {extraData?.data?.map((item,index) => (
                                <td>{item.val2}</td>
                              ))}
                            </tr>
                         </tbody>
                      </table> */}
                </Card>
              </Col>
            </Row>
          </div>
        </div> : null}

        <div>

          <Table
            tableLayout="auto"
            pagination={false}
            scroll={{ y: '70vh' }}
            style={{ marginTop: "32px" }}
            size="small"
            components={vt}
            columns={columns}
            onChange={handleTableChange}
            dataSource={filterData ? filterData : data ? data : []} />
        </div>

      </Spin>
    </div>

  );

}

export default Reports;